<template>
  <div :class="{ 'no-data': list.length == 0 }" class="upload-filelist">
    <div class="header">
      <div class="left">
        <div class="icon">
          <rt-icon :name="titleIcon" color="#fff" size="24" />
        </div>
        <div class="title">
          {{ title }}
        </div>
      </div>
      <div class="right">
        <slot name="right-top">
          <el-upload v-if="showButtons" ref="upload" :show-file-list="false" :on-success="handleSuccess"
            :before-upload="beforeUpload" :http-request="uploadFile" :file-list="fileList" action>
            <rt-button icon-name="rt-base-upload" type="primary">
              {{ $tx("上传文件", "xpc.uploadfile.uploadfile") }}
            </rt-button>
          </el-upload>
        </slot>
      </div>
    </div>
    <div class="content">
      <el-table v-if="list.length > 0" :data="list" stripe border>
        <el-table-column v-if="showRemark" :label="$tx('Attachment Type', 'xpc.uploadfile.type')" sortable
          prop="remark">
          <template slot-scope="scope">
            <p v-if="!scope.row.isEdit">
              {{ scope.row.remark }}
            </p>
            <div v-else class="cell-box">
              <el-input v-model="scope.row.remark" :placeholder="$tx('请填写备注', 'xpc.uploadfile.remarkplaceholder')
                " type="textarea" />
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$tx('文件名称', 'xpc.uploadfile.filename')" sortable prop="name" width="300">
          <template slot-scope="scope">
            <!-- 进度条 -->
            <div v-if="
              uploadFlag == true &&
              scope.row.uploadPercent > 0 &&
              scope.row.uploadPercent != 100
            " class="progress-box">
              <el-progress :percentage="scope.row.uploadPercent" :show-text="false" />
              <p class="progress">
                {{
                  $tx(
                    `已上传${scope.row.uploadPercent}`,
                    "xpc.uploadfile.uploaded",
                    {
                      count: scope.row.uploadPercent,
                    }
                  )
                }}%
              </p>
            </div>
            <!-- 非编辑状态 -->
            <!-- <div v-if="!scope.row.isEdit" class="noEdit">
              <rt-popover
                v-if="isImage(scope.row.name)"
                popper-class="rt-upload-slide-image"
                placement="left"
                trigger="hover"
              >
                <rt-image-preview
                  v-if="isImage(scope.row.name)"
                  :src="scope.row.url"
                  :preview-src-list="[scope.row.url]"
                />
                <rt-icon
                  v-else
                  :name="iconName(scope.row.name)"
                  :color="iconColor(scope.row.name)"
                  size="28"
                />
                <rt-image-preview
                  v-if="isImage(scope.row.name)"
                  slot="reference"
                  :src="scope.row.url"
                  :preview-src-list="[scope.row.url]"
                  style="width: 28px; height: 28px"
                />
                <rt-icon
                  v-else
                  slot="reference"
                  :name="iconName(scope.row.name)"
                  :color="iconColor(scope.row.name)"
                  size="28"
                />
              </rt-popover>
              <rt-icon
                v-else
                :name="iconName(scope.row.name)"
                :color="iconColor(scope.row.name)"
                size="24"
              />
              <span class="name" @click="itemClick(scope.$index)">{{
                scope.row.name
              }}</span>
            </div> -->
            <!-- 编辑状态 -->
            <!-- <div v-else class="cell-box">
              <el-input
                v-model="scope.row.name"
                :placeholder="
                  $tx('请填写文件名称', 'xpc.uploadfile.filenameplaceholder')
                "
              />
            </div> -->
            <p v-if="scope.row.name">
              {{ scope.row.name }}
            </p>
          </template>
        </el-table-column>
        <el-table-column :label="$tx('文件大小', 'xpc.uploadfile.filesize')" sortable prop="size" width="120">
          <template slot-scope="scope">
            <p v-if="scope.row.size">
              {{ scope.row.size }}
            </p>
          </template>
        </el-table-column>
        <el-table-column v-if="showTitle" :label="$tx('标题', 'xpc.uploadfile.title')" sortable prop="title">
          <template slot-scope="scope">
            <p v-if="!scope.row.isEdit">
              {{ scope.row.title }}
            </p>
            <div v-else class="cell-box">
              <el-input v-model="scope.row.title" :placeholder="$tx('请填写标题名称', 'xpc.uploadfile.titleplaceholder')
                " />
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$tx('操作', 'xpc.uploadfile.operate')" sortable prop="operation" align="left"
          min-width="120" width="300">
          <template slot-scope="scope">
            <div class="operation">
              <rt-list-button-group ref="buttonGroup" :max-btns="5">
                <rt-tooltip :content="$tx('编辑', 'xpc.uploadfile.edit')" placement="top">
                  <rt-button v-if="!scope.row.isEdit &&
                    showEdit" icon-name="rt-base-edit" text type="plain" @click="edit(scope.$index, scope)">
                  </rt-button>
                </rt-tooltip>
                <rt-tooltip :content="$tx('保存', 'xpc.uploadfile.save')" placement="top">
                  <rt-button v-if="scope.row.isEdit && showEdit" icon-name="rt-base-save-lined" text type="plain"
                    @click="save(scope.$index, scope)">
                  </rt-button>
                </rt-tooltip>
                <rt-tooltip :content="$tx('预览', 'xpc.uploadfile.preview')" placement="top">
                  <rt-button v-if="scope.row.isReview" icon-name="rt-base-eye-lined" text type="plain" @click="review(scope.$index, scope)">
                  </rt-button>
                </rt-tooltip>
                <rt-tooltip :content="$tx('下载', 'xpc.uploadfile.download')" placement="top">
                  <rt-button v-if="showDownload" icon-name="rt-base-download-lined" text type="plain"
                    @click="download(scope.$index, scope)">
                  </rt-button>
                </rt-tooltip>
                <rt-tooltip :content="$tx('删除', 'xpc.uploadfile.delete')" placement="top">
                  <rt-popconfirm v-if="showDelete" placement="bottom-end" :title="$tx(
                    '确定需要删除这条内容吗？',
                    'xpc.uploadfile.confirmdelete'
                  )
                    " @confirm="onConfirm(scope.row.name, scope.$index)">
                    <rt-button slot="reference" icon-name="rt-base-delete" text type="plain">
                    </rt-button>
                  </rt-popconfirm>
                </rt-tooltip>
              </rt-list-button-group>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <slot v-else name="empty">
        <rt-default-image size="medium">
          <div slot="describe">
            {{ $tx("暂无数据", "xpc.uploadfile.nodata") }}
          </div>
        </rt-default-image>
      </slot>
    </div>
  </div>
</template>

<script>
import RtIcon from "../icon/rtIcon";
import RtListButtonGroup from "../business/list/rtListButtonGroup";
import RtButton from "../button/rtButton";
import RtPopconfirm from "../popconfirm/rtPopconfirm";
import RtDefaultImage from "../defaultImage/rtDefaultImage";

export default {
  name: "RtUploadFilelist",
  components: {
    RtIcon,
    RtListButtonGroup,
    RtButton,
    RtPopconfirm,
    RtDefaultImage,
  },
  props: {
    uploadConf: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    title: {
      type: String,
      default() {
        return this.$tx("文件列表", "xpc.uploadfile.filelist");
      },
    },
    data: {
      type: Array,
      default: () => [],
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    showRemark: {
      type: Boolean,
      default: true,
    },
    showButtons: {
      type: Boolean,
      default: true,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    showDownload: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    uploadFileFn: {
      type: Function,
    },
    titleIcon: {
      type: String,
      default: "rt-base-orders_fill",
    },
  },
  data() {
    return {
      list: this.data,
      // 是否显示进度条
      uploadFlag: false,
      uploadPercent: "",
      fileList: [],
      index: -1,
    };
  },
  watch: {
    data(newValue) {
      this.$nextTick(() => {
        this.list = JSON.parse(JSON.stringify(newValue));
        this.list.map((item) => {
          if (item.mimetype) {
            const imageRegex = /^image\/(jpeg|png|gif|bmp|webp|svg\+xml|ico|tiff)$/i;
            item.isReview = imageRegex.test(item.mimetype);
          }
          console.log(222, item)
          this.$set(item, "isEdit", false);
        });
      });
    },
  },

  methods: {
    // 取文件后缀名
    fileSuffix(name) {
      return name.substring(name.lastIndexOf(".") + 1).toLowerCase();
    },
    itemClick(index) {
      this.$emit("item-click", index, this.data[index]);
    },
    download(index, item) {
      this.$emit("item-download", index, this.data[index]);
    },
    review(index, item) {
      this.$emit("item-review", index, this.data[index]);
    },
    // 上传前回调
    beforeUpload() { },
    // 上传成功回调
    handleSuccess() {
      this.index = -1;
    },
    uploadFile(file) {
      let obj = {
        uploadPercent: 0,
        url: "",
        name: file.file.name,
        size: file.file.size,
        title: "",
        remark: "",
        isEdit: false,
      };
      if (this.index >= 0) {
        this.list.splice(this.index, 1, obj);
      } else {
        this.list.push(obj);
      }

      if (this.$xpc.isFunction(this.uploadFileFn)) {
        this.uploadFileFn(this.uploadConf)
          .then(() => {
            this.uploadFlag = false;
            this.index = -1;
          })
          .catch(() => {
            this.uploadFlag = false;
          });
      }
    },
    edit(index, scope) {
      scope.row.isEdit = true;
      this.$emit("item-edit", index, scope.row);
    },
    save(index, scope) {
      scope.row.isEdit = false;
      this.$emit("item-save", index, scope.row);
    },
    reupload(index) {
      this.index = index;
      this.$refs.upload.$refs["upload-inner"].handleClick();
    },
    onConfirm(name, index) {
      this.del(name, index);
    },
    del(name, index) {
      this.$emit("item-delete", index, this.data[index]);
    },
    isImage(name) {
      return rt.isImageFile(this.fileSuffix(name));
    },
    // 根据文件后缀名显示对应的icon
    iconName(name) {
      const fileIconInfo = rt.getFileIconInfo(this.fileSuffix(name));
      return fileIconInfo && fileIconInfo.iconName;
    },
    // 根据文件后缀名显示对应的颜色值
    iconColor(name) {
      const fileIconInfo = rt.getFileIconInfo(this.fileSuffix(name));
      return fileIconInfo && fileIconInfo.iconColor;
    },
    // 文件大小 —— 用文件大小 / 1024，如果小于1024，显示 M，如果大于1024，再 / 1024，显示 G
    // 用Math.round(size * 100) / 100 四舍五入保留2位小数
    fileSize(size) {
      // 这里的size是比特单位
      let sizeKB = size / 1024;
      if (sizeKB >= 1024) {
        if (sizeKB / 1024 > 1024) {
          return (
            (Math.round((sizeKB / 1024 / 1024) * 100) / 100).toFixed(2) + "G"
          );
        } else {
          return (Math.round((sizeKB / 1024) * 100) / 100).toFixed(2) + "M";
        }
      } else {
        return sizeKB.toFixed(2) + "K";
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// rtUploadFilelist.vue?d6525c2e